/**
 * 项目默认配置项
 *
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 * props: {} - qiankun 子应用注入内容
 */
export default {
  // vue-ls options
  storageOptions: {
    namespace: 'pro__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local' // storage name session, local, memory
  }
}
